module.exports = __webpack_public_path__ + "static/media/screening_queue.8321fb32.svg";